<template>
  <v-container class="input-text-size">
    <v-overlay :value="overlay.flag">
      <v-progress-circular
        :rotate="-90"
        :size="100"
        :width="15"
        :value="overlay.value"
        color="primary"
      >
        {{ overlay.value }}
      </v-progress-circular>
    </v-overlay>
     <TransactionCriteria
     :baseCrudKey="baseCrudKey"
     @loadCRUDList="loadTransactionList"
   />
      <CRUDList
      ref="crudList"
      :canAdd="true"
      :headers='headers'
      :defaultSortBy="defaultSortBy"
      :displayTopPagination="false"
      :canEdit="true"
      :canSave="true"
      :showDate="true"
      :showTotal="true"
      :showSelect="true"
      :baseCrudKey="baseCrudKey"
      :selectedItems="selectedItems"
      :createNewItem="newItemDialog"
      tableWrapperDynamicClassname='elevation-3 ma-3 pa-3 taxroll-table-wrapper'
      tableDynamicClassname='taxroll-custom-table'
      tableDynamicHeight='250'
      @loadCRUDList="loadTransactionList"
      @upsertItem="upsertTransaction"
      @emitSelectedItem="emitSelectedItem"
      :variableToChangeRowBgColor="[{ varName: 'validateRecord', varCol: '#ffd180' }, { varName: 'isVoid', varCol: '#ffcdd2' }]"
      >
      <template v-slot:[`additionalActions`]="{}">
        <v-btn
           class="input-text-size" text color="blue darken-1"
           @click="taxPaymentReceipt()"
        >
        Tax Payment Receipt
        </v-btn>
      </template>
      <template v-slot:[`editedItem`]="{}">
        <TransactionEditedItem
          :baseCrudKey="baseCrudKey"
        />
      </template>
      <template v-slot:addidtionalCrudFooter>
        <tr style="width: 100%; display: inline-table;">
          <td width="30%"><h5 class="input-text-size align-right">{{ totalAmtOnSel }}</h5></td>
          <td width="10%"></td>
        </tr>
      </template>
      </CRUDList>
    <v-row dense class="mr-3 ml-3">
      <v-col cols="3">
        <!-- per zach, hiding this option for now
          <CommonReportInfo
          v-if="forceReloadDetails"
          :closeDialogBox="closeDialogBox"
          :reportType="reportType"
          @settingDialogVal="settingDialogVal"
        />
        <v-btn
          class="mt-2"
          small
          rounded
          color="primary"
          @click="openComponent('printPaymentList')"
        >
        Print Credit Card Payment List
        </v-btn> -->
        <v-btn
          v-if="isPayrix"
          class="mt-2"
          small
          rounded
          color="primary"
          @click="showPrintRngReportDialog = true"
        >
          Print Daily ReNewGov Report
        </v-btn>
        <v-btn
          v-if="isForte2"
          class="mt-2"
          small
          rounded
          color="primary"
          @click="showPrintRngReportDialog = true"
        >
          Print Daily ReNewGov Report (Forte)
        </v-btn>
        <v-btn
          v-if="!isPayrix"
          class="mt-2 ml-2"
          small
          rounded
          color="primary"
          @click="showFileContentsDialog = true"
        >
          File Contents Report
        </v-btn>
      </v-col>
      <v-toolbar flat>
      <v-text-field id="cc-trans-select-mark-date"
            class="mt-6 shrink"
            label="Select Date to Mark"
            type="date"
            v-model="markingDateForItems"
          >
        </v-text-field>
        <v-divider
          class="mx-4" inset vertical
        ></v-divider>
        <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="mx-2"
                  color="primary"
                  id="cc-bulk-mark-paid"
                  fab icon small
                  :disabled="!canMarkItemsPaidCancel"
                  @click="markItemsPaid"
                >
                  <v-icon>
                    {{ icons.mdiAlphaPCircle }}
                  </v-icon>
                </v-btn>
              </template>
              <span>Mark Paid</span>
            </v-tooltip>
        <v-tooltip bottom >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  id="voucher-bulk-mark-paid"
                  class="mx-2"
                  color="primary"
                  fab icon small
                  :disabled="canMarkItemsPaidCancel"
                  @click="markUnpaid"
                >
                  <v-icon>
                    {{ icons.mdiAlphaUCircle }}
                  </v-icon>
                </v-btn>
              </template>
              <span>Mark Unpaid</span>
            </v-tooltip>
      <v-divider class="mx-4" inset vertical></v-divider>
        <v-tooltip bottom >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  id="voucher-bulk-mark-paid"
                  class="mx-2"
                  color="primary"
                  fab icon small
                  :disabled="(selectedItems || []).length === 0"
                  @click="deleteItems"
                >
                  <v-icon>
                    {{ icons.mdiDelete }}
                  </v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
      <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
    </v-row>
    <v-dialog
      v-model="showPrintRngReportDialog"
      max-width="400"
    >
      <v-card>
        <v-card-title class="input-text-size flex">
          DAILY RENEWGOV REPORT
        </v-card-title>
        <v-card-text>
          <ClarionDateControl
            v-model="manualMarkDate"
            label="Report Date"
            :is-iso-date="true"
            :rules="clarionDateValidation()"
          />
          <div v-if="isGeneratingReport" class="text-center mt-4">
            <v-progress-circular
              indeterminate
              color="primary"
              :size="24"
              class="mr-2"
            ></v-progress-circular>
            Generating Report...
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :disabled="isGeneratingReport"
            @click="submitReportDate"
          >
            View/Print
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="showPrintRngReportDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showFileContentsDialog"
      max-width="400"
    >
      <v-card>
        <v-card-title class="input-text-size flex">
          FORTE FILE CONTENTS REPORT
        </v-card-title>
        <v-card-text>
          <ClarionDateControl
            v-model="fileContentsDate"
            label="File Date"
            :is-iso-date="true"
            :rules="clarionDateValidation()"
          />
          <div v-if="isGeneratingFileContents" class="text-center mt-4">
            <v-progress-circular
              indeterminate
              color="primary"
              :size="24"
              class="mr-2"
            ></v-progress-circular>
            Generating Report...
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :disabled="isGeneratingFileContents"
            @click="submitFileContentsReport"
          >
            View/Print
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="showFileContentsDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
   </v-container>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import {
  mdiAlphaPCircle,
  mdiAlphaUCircle,
  mdiDelete,
  mdiPrinter,
} from '@mdi/js';
import CRUDList from '../../../common/base/crud-2.0/CRUDList.vue';
import { ccPayemntsHeaders } from '../paymentutils/PaymentTransactionTableHeaders';
import '../../../../assets/style.css';
import TransactionCriteria from './TransactionCriteria.vue';
import TransactionEditedItem from './TransactionEditedItem.vue';
import {
  amountFormat,
  amountToNumber,
  defaultOverlayConfig,
  incrementOverlay,
  sanitizeZipCode,
} from '../../../../util/shared/vue-global';
import {
  toIsoDate,
} from '../../../../util/shared/tmc-global';
import { determineMerchantId } from '../../../../util/determineMerchantId.util';
import { clients } from '../../../../util/clients';
import ClarionDateControl from '../../../common/ClarionDateControl.vue';
import { generateQueryString } from '../../../common/base/report/report-util';

const { backendRest } = clients.direct;

const postProccess = (item) => {
  let postProccessData;
  if (Array.isArray(item)) {
    const newItem = [...item];
    postProccessData = newItem.map((trans) => {
      const updatedTrans = { ...trans };
      updatedTrans.validateRecord = (updatedTrans.systemDate === null
      && updatedTrans.paymentNo === null) || false;
      return updatedTrans;
    });
  }
  return postProccessData;
};

export default {
  name: 'creditcardpayments',
  created() {
    this.initCriteria();
  },
  data() {
    return {
      baseCrudKey: 'ccPaymentTransaction',
      headers: ccPayemntsHeaders,
      markingDateForItems: undefined,
      forceReloadDetails: false,
      reportType: '',
      overlay: defaultOverlayConfig(),
      icons: {
        mdiAlphaPCircle,
        mdiAlphaUCircle,
        mdiDelete,
        mdiPrinter,
      },
      showPrintRngReportDialog: false,
      manualMarkDate: '',
      isGeneratingReport: false,
      totalAmtOnSel: 0,
      showFileContentsDialog: false,
      fileContentsDate: '',
      isGeneratingFileContents: false,
    };
  },
  components: {
    TransactionCriteria,
    CRUDList,
    TransactionEditedItem,
    // CommonReportInfo, // per zach, hiding this option for now
    ClarionDateControl,
  },
  computed: {
    ...mapGetters(['todaysDate']),
    ...mapGetters('base/crud', [
      'criteria',
      'index',
      'item',
      'items',
    ]),
    ...mapState({
      storedSelectedItems: (state) => state.tax.ccPayments.selectedItems || [],
      nextPaymentNumber: (state) => state.tax.ccPayments.nextPaymentNumber,
      lastSavedCCPayment: (state) => state.common.payrixPayment.lastSavedPaymentItem,
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem || {},
      odSettingItem: (state) => state.SystemConfig.odSettingItem || {},
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    selectedItems: {
      get() {
        return this.storedSelectedItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    canMarkItemsPaidCancel() {
      const hasSelectedItems = (this.selectedItems || []).length > 0;
      const hasDate = (this.markingDateForItems || '').length > 0;
      return hasSelectedItems && hasDate;
    },
    defaultSortBy() {
      /* most recent business date first; paymentNo only breaks ties within a
      business date. Counties that never mark CC records paid were otherwise
      seeing the highest payment number on top. */
      return [
        {
          column: 'systemDate',
          direction: 'desc',
        },
        {
          column: 'paymentNo',
          direction: 'desc',
        },
      ];
    },
    isPayrix() {
      const settings = this.odSettingItem;
      return settings.selectedGateway === 'payrix';
    },
    isForte2() {
      const settings = this.odSettingItem;
      return settings.selectedGateway === 'forte2';
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setCriteria']),
    ...mapActions(['flashInfo', 'flashSuccess', 'flashError', 'reAuth']),
    ...mapActions('tax/ccPayments', [
      'loadCCPaymentsTrans',
      'upsertCCPaymentsTrans',
      'loadLastPaymentNo',
      'delCCPaymentsTrans',
    ]),
    ...mapMutations('tax/ccPayments', [
      'setSelectedItems',
    ]),
    handleLoadCRUDList(criteriaArgs) {
      const { baseCrudKey } = this;
      this.loadCCPaymentsTrans({ criteria: this.criteriaState, baseCrudKey, postProccess })
        .then(() => {
          this.setDefaultSelectedItems(criteriaArgs);
        }).catch((e) => {
          console.warn(e);
          this.setDefaultSelectedItems(criteriaArgs);
        });
    },
    async upsertTransaction(item) {
      const paymentSettings = this.paymentSettingItem;
      const { baseCrudKey } = this;
      const updatedItem = { ...item };
      delete updatedItem.validateRecord;
      if (updatedItem.merchantId == null) {
        const derivedMerchantId = determineMerchantId(item, paymentSettings);
        if (derivedMerchantId != null) {
          updatedItem.merchantId = derivedMerchantId;
        }
      }
      updatedItem.maskedAccount = amountToNumber(updatedItem.maskedAccount);
      // NOT amountToNumber: a currency parser keeps "466.37" as a float, which the
      // GraphQLInt zipCode field then refuses to serialize (McCurtain, Jul 2026).
      updatedItem.zipCode = sanitizeZipCode(updatedItem.zipCode);
      delete updatedItem.isTrusted;
      if ((updatedItem.taxDetails || []).length > 0) {
        updatedItem.taxDetails = updatedItem.taxDetails.map((element) => {
          const detailItem = { ...element };
          detailItem.taxId = amountToNumber(detailItem.taxId);
          detailItem.taxAmount = amountToNumber(detailItem.taxAmount);
          detailItem.penalty = amountToNumber(detailItem.penalty);
          detailItem.feeTotal = amountToNumber(detailItem.feeTotal);
          detailItem.total = amountToNumber(detailItem.total);
          return { ...detailItem };
        });
      }
      const response = await this.upsertCCPaymentsTrans({
        item: updatedItem,
        baseCrudKey,
        postProccess,
      });
      return response;
    },
    emitSelectedItem(item) {
      this.selectedItems = item;
      const calcAmountOnSelectedRecords = (this.selectedItems || []).reduce((total, items) => Number(total)
      + (Number(items.amountPaid)), 0);
      this.totalAmtOnSel = amountFormat(calcAmountOnSelectedRecords) || 0;
    },
    async getPayment() {
      for (let i = 0; i < (this.selectedItems || []).length; i += 1) {
        const updateItem = this.selectedItems[i];
        updateItem.status = 'PAID';
        updateItem.paidClearedDate = this.markingDateForItems;
        await this.upsertTransaction(updateItem);
      }
    },
    async fetchUnpaidTrans() {
      const isoData = toIsoDate(this.markingDateForItems);
      const params = {
        status: 'PAID',
        paidClearedDate: isoData,
      };
      const result = await this.loadCCPaymentsTrans({
        criteria: params, baseCrudKey: this.baseCrudKey, postProccess,
      });
      return result;
    },
    async markItemsPaid() {
      if (window.confirm(`Are you sure want to update ${(this.selectedItems || []).length} record/s?`)) {
        this.overlay.flag = true;
        const checkTransStatus = this.selectedItems.some((el) => el.status === 'OUTSTANDING');
        if (checkTransStatus) {
          await this.getPayment();
        } else {
          this.flashInfo('One or more transactions were already paid.');
        }
      }
      this.loadTransactionList();
      this.overlay = defaultOverlayConfig();
      // this.setDefaultSelectedItems();
    },
    setDefaultSelectedItems(criteriaArgs = {}) {
      if (criteriaArgs.searchMode === 'wildcard') {
        this.$nextTick(() => {
          this.selectedItems = [...this.selectedItems];
        });
      } else {
        this.$nextTick(() => {
          this.selectedItems = [];
        });
      }
    },
    async taxPaymentReceipt() {
      const item = this.item(this.baseCrudKey);
      const processPayment = {
        transactionId: item.transactionId,
        cardType: item.specialPaymentType,
        cardholderName: item.paidBy,
        paidAmt: item.amountPaid,
        processingFee: item.processingFee || 0,
        taxPayerEmail: '',
      };
      const payload = {
        processedPayment: processPayment,
        taxDetails: item.taxDetails,
        paymentMethod: item.paymentType,
      };
      const receiptResponse = await backendRest.post('/tax/ccPayments/forte/taxpayer-receipt', payload,
        { responseType: 'blob' });
      const blob = new Blob([receiptResponse.data], { type: 'application/pdf' });
      const blobUrl = window.URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');
    },
    async markUnpaid() {
      const isoData = toIsoDate(this.markingDateForItems);
      const response = await this.fetchUnpaidTrans();
      const responseLength = (response || []).length;
      if (responseLength === 0) {
        this.flashInfo(`On ${isoData} date nothing needs to be unpaid.`);
      } else
      if (window.confirm(`Are you sure want to unpay ${responseLength} record/s?`)) {
        this.overlay.flag = true;
        for (let i = 0; i < responseLength; i += 1) {
          const item = response[i];
          const upsItem = {
            ...item,
            _id: item._id,
            status: 'OUTSTANDING',
            paidClearedDate: null, // for date datatype
          };
          await this.upsertTransaction(upsItem, true);
          incrementOverlay(this, responseLength, i);
        }
        this.flashSuccess('Record/s marked Unpaid.');
      }
      this.loadTransactionList();
      this.overlay = defaultOverlayConfig();
    },
    loadTransactionList(criteriaArgs = {}) {
      const criteria = { ...this.criteriaState };
      if (criteria.isShowPaidRecords) {
        criteria.status = null; /* no filter for status, so records
        of status = 'outstanding' and status = 'paid' will be loaded */
      } else {
        criteria.status = 'OUTSTANDING';
      }
      if (criteria.systemDate === '') {
        criteria.systemDate = null;
      }
      if (criteria.paymentDate === '') {
        criteria.paymentDate = null;
      }
      if (criteria.paidClearedDate === '') {
        criteria.paidClearedDate = null;
      }
      // convert date to iso date
      if (criteria.paymentDate && criteria.paymentDate !== '') {
        criteria.paymentDate = toIsoDate(criteria.paymentDate);
      }
      if (criteria.paidClearedDate && criteria.paidClearedDate !== '') {
        criteria.paidClearedDate = toIsoDate(criteria.paidClearedDate);
      }
      if (criteria.systemDate && criteria.systemDate !== '') {
        criteria.systemDate = toIsoDate(criteria.systemDate);
      }
      if ((criteria.paymentDate && criteria.paidClearedDate && criteria.systemDate)
       || criteria.specialPaymentType || criteria.status
      || criteria.isShowPaidRecords || criteria.isTempRecord
      ) {
        this.loadCCPaymentsTrans({
          criteria, baseCrudKey: this.baseCrudKey, postProccess,
        }).then(() => {
          this.setDefaultSelectedItems(criteriaArgs);
        });
      }
    },
    async deleteItems() {
      if (window.confirm(`CAREFUL! Are you sure you want to DELETE ${(this.selectedItems || []).length} record/s?`)) {
        for (let i = 0; i < (this.selectedItems || []).length; i += 1) {
          const item = this.selectedItems[i];
          await this.delCCPaymentsTrans({ item, baseCrudKey: this.baseCrudKey });
        }
      }
      this.selectedItems = [];
    },
    openComponent(val) {
      this.reportType = val;
      this.closeDialogBox = true;
      this.forceReloadDetails = true;
    },
    settingDialogVal(value) {
      this.closeDialogBox = value;
      this.forceReloadDetails = false;
    },
    newItemDialog() {
      let newItem = {};
      newItem = {
        paymentNo: null,
        status: 'OUTSTANDING',
        systemDate: this.todaysDate,
      };
      this.loadLastPaymentNo();
      return newItem;
    },
    initCriteria() {
      this.criteriaState = {};
      // this.criteriaState.systemDate = null;
      this.markingDateForItems = this.todaysDate;
    },
    async submitManualMarkDate() {
      if (!this.manualMarkDate || !/^\d{4}-\d{2}-\d{2}$/.test(this.manualMarkDate)) {
        this.flashInfo('Invalid date format. Please select a valid date.');
        return;
      }
      this.isGeneratingReport = true;
      try {
        const inputtedDate = this.manualMarkDate.replace(/-/g, '');
        const pdfResponse = await backendRest.post(
          '/tax/ccPayments/payrix/daily-renewgov-report',
          { reportDate: inputtedDate },
          { responseType: 'blob' },
        );
        const blob = new Blob([pdfResponse.data], { type: 'application/pdf' });
        const blobUrl = window.URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
        this.showPrintRngReportDialog = false;
      } catch (error) {
        this.flashInfo('Error generating report. Please try again.');
        console.error(error);
      } finally {
        this.isGeneratingReport = false;
      }
    },
    async submitForte2ReportDate() {
      if (!this.manualMarkDate || !/^\d{4}-\d{2}-\d{2}$/.test(this.manualMarkDate)) {
        this.flashInfo('Invalid date format. Please select a valid date.');
        return;
      }
      this.isGeneratingReport = true;
      try {
        const inputtedDate = this.manualMarkDate.replace(/-/g, '');
        const pdfResponse = await backendRest.post(
          '/tax/ccPayments/forte2/daily-renewgov-report',
          { reportDate: inputtedDate },
          { responseType: 'blob' },
        );
        const blob = new Blob([pdfResponse.data], { type: 'application/pdf' });
        const blobUrl = window.URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
        this.showPrintRngReportDialog = false;
      } catch (error) {
        this.flashInfo('Error generating report. Please try again.');
        console.error(error);
      } finally {
        this.isGeneratingReport = false;
      }
    },
    submitReportDate() {
      if (this.isForte2) {
        return this.submitForte2ReportDate();
      }
      return this.submitManualMarkDate();
    },
    // "What is in the file" report -- re-reads the file straight off SFTP, runs no
    // validation, and writes nothing. Not to be confused with the Forte import flow.
    async submitFileContentsReport() {
      if (!this.fileContentsDate || !/^\d{4}-\d{2}-\d{2}$/.test(this.fileContentsDate)) {
        this.flashInfo('Invalid date format. Please select a valid date.');
        return;
      }
      this.isGeneratingFileContents = true;
      try {
        const dateStr = this.fileContentsDate.replace(/-/g, '');
        const { jwt } = await this.reAuth();
        const params = [`token=${jwt}`, `date=${dateStr}`];
        const queryString = generateQueryString(params);
        const contentsResponse = await backendRest.get(`/tax/ccPayments/forte/file-contents${queryString}`);
        const pdfResponse = await backendRest.post(
          '/tax/ccPayments/forte/file-contents-pdf',
          contentsResponse.data,
          { responseType: 'blob' },
        );
        const blob = new Blob([pdfResponse.data], { type: 'application/pdf' });
        const blobUrl = window.URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
        this.showFileContentsDialog = false;
      } catch (error) {
        console.error('Error generating Forte file contents report:', error);
        const message = (error.response && error.response.data && error.response.data.error) || 'Error generating file contents report.';
        this.flashError(message);
      } finally {
        this.isGeneratingFileContents = false;
      }
    },
    clarionDateValidation() {
      const internalRules = [
        (value) => {
          const hasValue = !!value;
          if (!hasValue) {
            return (this.isRequired) ? 'Required' : true;
          }
          return true;
        },
        (value) => {
          if (this.isRequired || !!value) {
            const valueStr = (value || '').toString();
            const isMatch = valueStr.match(/^[0-9]+[/\\-][0-9]+[/\\-][0-9]+$/);
            if (!isMatch && valueStr.length > 0) {
              return 'Unexpected characters, or date is not in MM-DD-YYYY format.';
            }
          }
          return true;
        },
      ];
      return [
        ...internalRules,
        ...(this.rules || []),
      ];
    },
  },
};
</script>
